import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import LicensePlanUpdateMenuItem from "@/v2-backoffice-client/license/plan/update/LicensePlanUpdateMenuItem"
import LicensePlanDeprecateMenuItem from "@/v2-backoffice-client/license/plan/deprecate/LicensePlanDeprecateMenuItem"
import { FENERUM_PLAN_BASE_URL } from "@/v2-backoffice-client/constants"
import type { LicensePlanFragment } from "@/v2-backoffice-client/license/plan/__types__/license.plan.fragment"

export type LicensePlanTableRowToolbarProps = {
  plan: LicensePlanFragment
}

// The app-owned edits a license row offers: the license's product and seat
// semantics, and its deprecation — everything else on it is Fenerum's and
// would be overwritten on the next sync (the deep link goes to the system
// that owns it). Deprecating sits apart, below a separator and in red: it
// marks the license as being retired everywhere it shows.
function LicensePlanTableRowToolbar(props: LicensePlanTableRowToolbarProps) {
  const { plan } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />
      <ActionMenu.Content>
        <ActionMenu.LinkItem iconSrc="expand" to={`?v=plan:${plan.Id}`}>
          Open Panel
        </ActionMenu.LinkItem>

        <ActionMenu.LinkItem
          iconSrc="bank"
          to={`${FENERUM_PLAN_BASE_URL}/${plan.ExternalPlanUuid}/`}
          external
        >
          Open in Fenerum
        </ActionMenu.LinkItem>

        <LicensePlanUpdateMenuItem plan={plan} />

        <ActionMenu.Separator />
        <LicensePlanDeprecateMenuItem plan={plan} />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LicensePlanTableRowToolbar
